import React, { useRef } from 'react';
var VeltCommentPinUnreadCommentIndicator = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-pin-unread-comment-indicator", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentPinUnreadCommentIndicator;
